module.exports = __webpack_public_path__ + "static/media/menu.d88a59d8.svg";